import {array} from 'prop-types';
import React, {Component} from 'react';

import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {MESSAGE} from "../../../../../wpconfig"

import * as func from "../../../../../utils/functions";
import * as Actions from "../../../../../store/modules/journals";
import * as FActions from "../../../../../store/modules/footer";

class IndicatorItem extends Component {
	constructor(props) {
		super(props);
	}

	openPopup = (type) => {
		this.props.openPopup(type, this.props.id)
	}

	onRemove = () => {
		if (confirm(this.props.type + '(' + this.props.year + ') Indicator 를 ' + MESSAGE.DELETE)) {
			this.props.id &&
			func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/" + this.props.id + "/delete").then((response) => {
				if (response.code === 'ok') {
					this.props.showMessage('삭제 되었습니다.')
					this.props.onRemove(this.props.arrIndex)
				} else {
					this.props.showMessage('삭제 실패 : ' + response.message)
				}
			})
		}
	}

	render() {

		return (
			<tr>
				<td>{this.props.type==='jcr' ? 'JCR' : (this.props.type==='scopus' ? 'Scopus' : (this.props.type==='kci' ? 'KCI' : this.props.type))}</td>
				<td>{this.props.year}</td>
				<td>{this.props.impact}</td>
				<td>{this.props.eigenfactor}</td>
				<td>
					{
						this.props.ranking &&
						this.props.ranking.map((v, idx) => {
							let db_type = ''
							if(v.indicator_type === 'jcr') {
								if(v.ranking_type === 'jci') db_type = 'JCI, '
								else db_type = v.edition + ", "
							} else {
								db_type = ""
							}
							return (
								<span key={idx} className="mr-2">
									<div key={idx} className="tooltip">
										<span className="tooltip-text">{v.category_name}</span>
										<span className="bg-secondary">{v.category_code}</span>
										{"(" + db_type + v.ranking + "/" + v.category_count + ", " + v.percent + "%) "}
									</div>
								</span>
							)
						})
					}
				</td>
				<td className="align-middle">
					<div className="btn-group">
						{/* <button type="button" className="btn btn-outline-success btn-sm" onClick={() => this.props.togglePopup()}>상세</button> */}
						<button type="button" className="btn btn-outline-primary btn-sm"
						        onClick={() => this.openPopup(this.props.type)}>수정
						</button>
						<button type="button" className="btn btn-outline-danger btn-sm" onClick={this.onRemove}>삭제</button>
					</div>
				</td>
			</tr>
		)
	}
}

export default IndicatorItem